
























import { Component, Mixins } from 'vue-property-decorator';

import { SettingsModule } from '@/store/modules/settings';
import { AppMain, Navbar, Sidebar, TagsView } from './components';
import ResizeMixin from './mixin/resize';
import { UserModule } from '@/store/modules/user';
import { parseTime } from '@/utils/function_utils';
import { getGearReleaseData, setGearReleaseData } from '@/utils/storage_local';
import { getNewsByTypeNameApi } from '@/api/index';
import { popupNoticeCurrentApi } from '@/api/popupNotice';
import { buildPopupNoticeSessionKey, setPopupNoticeSessionKey } from '@/utils/storage_session';

import bmsUpdateReminder from '@/components/Common/release-dialog.vue';
import applyTipsDialog from '@/components/Common/applyTipsDialog.vue';
import PopupNoticeDialog from '@/components/popup-notice/popup-notice-dialog.vue';

@Component({
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    Sidebar,
    TagsView,
    bmsUpdateReminder,
    applyTipsDialog,
    PopupNoticeDialog
  },
})
export default class extends Mixins(ResizeMixin) {
  get classObj() {
    return {
      hideSidebar: !this.sidebar.opened,
      withoutAnimation: this.sidebar.withoutAnimation,
    };
  }

  get showTagsView() {
    return SettingsModule.showTagsView
  }

  get fixedHeader() {
    return SettingsModule.fixedHeader;
  }

  get expiresIn() {
    return UserModule.expiresIn;
  }

  get loginTime() {
    return UserModule.loginTime;
  }

  get token() {
    return UserModule.token;
  }

  // 全局定时器
  private timer: any = null;
  // 发布内容
  public releasContent:any='';
  public title:any='';
  // 是否已弹出 BMS更新发布提醒窗口
  public isShowRelease:boolean=false;
  public releaseTime:any=null;
  public popupNoticeTimer:any=null;

  public async created() {
    await this.checkExpires();
    if (this.token) {
      this.expiresInterval();
      this.checkReleaseDetail();
      this.$nextTick(() => {
        this.checkDialogSort();
      });
      this.startPopupNoticePolling();
    }
  }

  public beforeDestroy() {
    this.clearExpiresInterval();
    clearInterval(this.popupNoticeTimer);
  }

  // 定时计算超时时间
  private expiresInterval() {
    this.timer = setInterval(this.checkExpires, 1000);
  }

  private clearExpiresInterval() {
    clearInterval(this.timer);
    this.timer = null;
  }

  // 登录后弹窗顺序：先处理原有申请草稿提示，再展示通知与反馈弹窗。
  public async checkDialogSort() {
    const applyTipsEl: any = this.$refs.applyTipsDialog;
    if (applyTipsEl && typeof applyTipsEl.checkApplyData === 'function') {
      const hasApplyTips = await applyTipsEl.checkApplyData();
      if (hasApplyTips) {
        return;
      }
    }
    this.checkPopupNoticeData();
  }

  // 获取当前GEAR通知弹窗。接口与GEAR3保持一致，原有更新提醒弹窗不受影响。
  public async checkPopupNoticeData() {
    try {
      const popupEl: any = this.$refs.popupNoticeDialog;
      if (popupEl && popupEl.isShow) {
        return;
      }
      const sessionKey = buildPopupNoticeSessionKey(
        'GEAR',
        UserModule.onlineAgentUserId || UserModule.staffId || UserModule.loginId
      );
      setPopupNoticeSessionKey(sessionKey);
      const { data }: any = await popupNoticeCurrentApi({
        systemScope: 'GEAR',
        currentPath: this.$route.path,
        sessionKey
      });
      if (data.code !== '1003') {
        return;
      }
      const noticeList = data.datas || data.data || [];
      if (Array.isArray(noticeList) && noticeList.length) {
        const popupEl: any = this.$refs.popupNoticeDialog;
        popupEl && popupEl.open(noticeList);
      }
    } catch (err) {
      // 通知弹窗不阻断主界面加载
    }
  }
  public startPopupNoticePolling() {
    clearInterval(this.popupNoticeTimer);
    this.popupNoticeTimer = setInterval(() => {
      this.checkDialogSort();
    }, 8 * 60 * 1000);
  }
  // 检查是否token超时失效，如失效则刷新token
  private async checkExpires() {
    const nowDate = new Date().getTime();
    const loginDate = new Date(this.loginTime).getTime();
    if (nowDate - loginDate >= +this.expiresIn * 1000) {
      try {
        await UserModule.RefreshToken();
      } catch (err) {
        this.clearExpiresInterval();
      }
    }
  }
  // 持续获取是否需要弹出更新弹窗
  public checkReleaseDetail(){
    clearInterval(this.releaseTime);
    this.releaseTime=null;
    this.releaseTime=setInterval(()=>{
      this.getDetail()
    },300000)
  }
  // 获取新闻详情（更新提醒）
  // 弹出要求
  // 1：当前时间等于发布时间，如果已存内容跟最新内容不一样，弹窗
  public async getDetail(){
    const {data}:any=await getNewsByTypeNameApi();
    if(data.code==='1003'){
      // 没内容不显示
      if(!data.data.description||!data.data.publishTime){
        return
      }
      // 发布时间
      let publishTime:any='';
      // 当前时间
      let newDate:any=parseTime(new Date(),'{y}-{m}-{d}')
      newDate=new Date(newDate).getTime()
      // 转化时间
      if(data.data.publishTime){
        publishTime=new Date(data.data.publishTime).getTime()
      }
      // 发布时间，当前时间，没弹窗
      if(publishTime&&newDate&&this.isShowRelease===false){
        // 发布时间=当前时间
        if(publishTime===newDate){
          // 获取曾经储存过的内容
          const oleValue:any=getGearReleaseData()
          // 没值，或者 已存值跟发布内容不一样，弹窗，并保存最新内容
          if(!oleValue||oleValue!==data.data.description){
            this.releasContent=data.data.description;
            this.title=data.data.title;
            const el:any=this.$refs.bmsUpdateReminder;
            el.isShow=true;
            this.isShowRelease=true;
            setGearReleaseData(this.releasContent)
          }
        }
      }
    }
  }
  // 关闭发布弹窗
  public releaseClose(){
    this.isShowRelease=false;
  }
}
